module.exports = __webpack_public_path__ + "img/LtBootNugMe.6e602317.jpg";